import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import Header from '@components/header'
import { columnShapesTable } from '@utils/columns'
import { getToday } from '@utils/time'
import Layout from '@components/Layout'
import { useQuery } from '@tanstack/react-query'
import { debouncedSet } from '@utils/debounce'
import { http } from '@services/http'
import { fetchItemsGroups } from '@utils/fetchData'
import EditShapesTableModal from '@components/Modal/editShapesTableModal'

const ItemShapesTable = () => {
	const { t } = useTranslation()
	const formattedDate = getToday()

	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)
	const [selectedViewRowData, setSelectedViewRowData] = useState(null)
	const [currentPage, setCurrentPage] = useState(0)
	const [itemName, setItemName] = useState('')
	const [itemCode, setItemCode] = useState('')
	const [category, setCategory] = useState('')
	const [itemType, setItemType] = useState('')

	const fetchItems = async ({ queryKey }) => {
		const [_, itemName, category, page] = queryKey
		try {
			let url = `api/items/get-items?itemName=${itemName}&categories=107&pageSize=10&pageToken=${page}`
			const { data } = await http.get(url)
			return data.data
		} catch (error) {
			console.log(error)
		}
	}

	const {
		data = [],
		isLoading,
		refetch,
	} = useQuery({
		queryKey: ['itemsShapesTable', itemName, category, currentPage],
		queryFn: fetchItems,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})
	const { data: itemsGroupData = [], isLoading: itemsLoading } = useQuery({
		queryKey: ['itemsGrp'],
		queryFn: fetchItemsGroups,
		keepPreviousData: true,
		refetchOnWindowFocus: false,
	})

	const handleNextPage = () => {
		if (data.length === 10) {
			setCurrentPage((prevPage) => prevPage + 1)
		}
	}

	const handlePreviousPage = () => {
		if (currentPage > 0) {
			setCurrentPage((prevPage) => prevPage - 1)
		}
	}

	const handleViewRowClick = (record) => {
		setSelectedViewRowData(record)
		setIsViewModalVisible(true)
	}

	const handleItemNameChange = (val) => {
		debouncedSet(val, setItemName)
	}

	const handleCategoryChange = (val) => {
		debouncedSet(val, setCategory)
	}

	const columns = columnShapesTable(
		t,
		handleViewRowClick,
		handleItemNameChange,
		handleCategoryChange,
	)

	return (
		<Layout>
			<Header
				title={'itemsShapesTable'}
				currentPage={currentPage + 1}
				handlePreviousPage={handlePreviousPage}
				handleNextPage={handleNextPage}
				hasMoreData={data.length === 10}
				columns={columns}
				fdata={data}
				loading={isLoading}
				formattedDate={formattedDate}
				isSticky={false}
			/>

			<EditShapesTableModal
				visible={isViewModalVisible}
				data={selectedViewRowData}
				onClose={() => {
					setIsViewModalVisible(false)
					refetch()
				}}
			/>
		</Layout>
	)
}

export default ItemShapesTable
